// Pure geometry for the group drag-reorder (drop-index detection and ghost sizing), extracted
// from Bpmn.vue so it can be unit-tested independently of the component.

const SLOT_WIDTH = 160

// Effective width of a group for drop detection. The last group has width -1 (it renders to the
// canvas edge), so use its content extent (rightmost event + one slot) instead of the full canvas.
export const groupWidthForDrop = (group, rightmostEventX) => (
  group.width > 0 ? group.width : Math.max(SLOT_WIDTH, (rightmostEventX + SLOT_WIDTH) - group.x)
)

// Insertion index for the dragged group, given the leading edges of its ghost and the midpoints
// of the other groups (each tagged with whether it started left of the dragged one).
export const computeDropIndex = (leftEdge, rightEdge, others) => {
  let index = 0
  for (const other of others) {
    if (other.before) {
      if (leftEdge >= other.mid) {
        index++
      }
    } else if (rightEdge > other.mid) {
      index++
    }
  }

  return index
}

// Ghost rect position/width. When dropping into the first slot the ghost extends left by the
// lane-width offset so it reaches the lane (the first group renders wider).
export const computeGhost = (leftEdge, draggedWidth, firstGroupExtra, dropIndex) => {
  const extra = dropIndex === 0 ? firstGroupExtra : 0

  return {
    ghostLeft: Math.max(0, leftEdge - extra),
    ghostWidth: draggedWidth + extra
  }
}
